import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Trophy } from "lucide-react";
import { Stars } from "./RateDriverDialog";
import DriverBadges from "./DriverBadges";

export default function TopDrivers() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/gigs/drivers/top").then((r) => setList(r.data)).catch(() => {}); }, []);
  if (list.length === 0) return null;
  return (
    <div className="p-5 rounded-2xl bg-[#131722] border border-slate-800" data-testid="top-drivers-card">
      <p className="text-xs font-mono uppercase tracking-widest text-slate-400 flex items-center gap-1.5 mb-3"><Trophy className="w-3.5 h-3.5 text-amber-400" />Top drivers</p>
      <ol className="space-y-2">
        {list.map((d, i) => (
          <li key={d.user_id} className="flex items-center gap-3 text-sm" data-testid={`top-driver-${d.user_id}`}>
            <span className="font-mono text-slate-500 w-4">{i + 1}</span>
            <span className="flex-1 truncate flex items-center gap-1.5 min-w-0">{d.name}<DriverBadges badges={d.badges} compact /></span>
            <Stars value={d.driver_rating_avg} count={d.driver_rating_count} />
            <span className="text-[11px] text-slate-500">{d.deliveries} runs</span>
          </li>
        ))}
      </ol>
      <p className="text-[11px] text-slate-500 mt-3">4.5★+ with 3+ rated deliveries unlocks 15-minute early access to every new job.</p>
    </div>
  );
}
